import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import posthog from 'posthog-js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

console.log(`Environment: ${environment.name}`);

posthog.init(
  'phc_Qp5Ea9ck4zZ6Ng3iksTzWPAPrXXvGuSPitvjK8qikAc',
  {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true
  }
);

Sentry.init({
  dsn: "https://a19b04e861f6fe97b5dbd731611b1c61@o4510788896948224.ingest.us.sentry.io/4510800892723200",
  sendDefaultPii: true,
  enabled: true,
  environment: environment.name,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    Sentry.browserTracingIntegration()
  ],
  replaysSessionSampleRate: environment.production ? 1 : 0,
  replaysOnErrorSampleRate: 1,
  enableLogs: true,
  tracesSampleRate: 1,
  tracePropagationTargets: ["api.tamis.app.br", "tamis.app.br", "localhost", "dev.tamis.app.br", "igesto-dev2.web.app", "igesto-dev3.web.app"],
  transport: options => {
    const transport = Sentry.makeFetchTransport(options);
    return {
      ...transport,
      send: async (...args) => {
        try {
          return await transport.send(...args);
        } catch (e) {
          console.warn('Sentry transport failed:', e);
          return { statusCode: 200 }; // Suppress errors
        }
      }
    };
  }
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
